import React, {useEffect, useState} from 'react';
import {Avatar, Checkbox, Menu, Select, SelectProps, Space} from 'antd';

import {ReactComponent as SelectArrayIcon} from '../../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../../../assets/i/arrow-up-icon.svg';
import {ReactComponent as CloseFormIcon} from '../../../../../../assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {setStudentsIds} from "features/model/slice/create-test/create-test-form/createTestForm";


interface Student {
    id: number;
    fullName: string;
    avatar: string;
}

interface SelectModeStudentProps {
    onSelect: (selectedStudentIds: number[]) => void;
    onClearStudents:()=> void
    setSelectedStudentIds: (value: number[]) => void;
}

export const SelectModeStudent: React.FC<SelectModeStudentProps> = ({onSelect,onClearStudents,setSelectedStudentIds}) => {
    const {items, pagination, error, isLoading} = useAppSelector(state => state.studentListing);

    const [value, setValue] = useState<number[]>([]);

    useEffect(() => {
        setSelectedStudentIds(value)
    }, [value]);

    useEffect(() => {
        if (value.length === 0) {
            onClearStudents();
        }
    }, [value]);



    const [open, setOpen] = useState<boolean>(false);

    const shouldAllowClear = value.length >= 2;

    const handleClear = () => {
        setValue([]);
        onSelect([])
    };


    const customClearIcon = (
        <CloseFormIcon
            onClick={() => {
                handleClear()
            }}
        />
    );


    const options: { value: number; label: React.ReactNode; avatar: string }[] = items.map((item: Student) => ({
        value: item.id,
        label: (
            <>
                {item.fullName}
            </>
        ),
        avatar: item.avatar,
    }));


    const selectProps: SelectProps = {
        mode: 'multiple',
        style: {width: '100%'},
        value,
        options,
        onChange: (newValue: number[]) => {
            setValue(newValue);
        },
        maxTagCount: 'responsive',
        onDropdownVisibleChange: (visible) => {
            setOpen(visible);
        },
        showSearch: false,
        dropdownRender: (menu) => (
            <Menu>
                {options.map((option) => (
                    <Menu.Item key={option.value}>
                        <Checkbox
                            checked={value.includes(option.value)}
                            onChange={() => {
                                const newValue = value.includes(option.value)
                                    ? value.filter((val) => val !== option.value)
                                    : [...value, option.value];
                                setValue(newValue);
                                onSelect(newValue);
                            }}
                            className="custom-checkbox"
                        >
                            {option.label}
                        </Checkbox>
                    </Menu.Item>
                ))}
            </Menu>
        ),
    };

    return (
        <div className="inp-box">
            <div id="select-mode">
                <Space direction="vertical" style={{width: '100%', cursor: 'pointer'}}>
                    <Select
                        {...selectProps}
                        allowClear={shouldAllowClear}
                        clearIcon={customClearIcon}
                        placeholder={<span className='placeholder-text'>Студенты</span>}
                        className={`custom-select ${open ? 'custom-select-open' : 'custom-select-closed'}`}
                        suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                    />
                </Space>
            </div>
        </div>
    );
};
